module.exports = __webpack_public_path__ + "img/view-history@3x.4fe1e425.png";